import MainButton from "@components/common/Button";
import { Box, Button, Typography } from "@mui/material";
import { DeliveryStatus } from "@types_def/models/delivery.types";

type Props = {
  updateDeliveryStatusBySMS: (status: DeliveryStatus) => void;
};

function Buttons({ updateDeliveryStatusBySMS }: Props) {
  return (
    <>
      <Typography sx={{ mb: 2 }}>
        Veuillez valider ces informations en cliquant sur les lien ci-dessous.
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <MainButton
          buttonTheme="secondary"
          noFill={false}
          onClick={() => {
            updateDeliveryStatusBySMS(DeliveryStatus.CONFIRMED_BY_CUSTOMER);
          }}
          sx={{
            padding: { xs: "1rem", md: "2rem" },
            fontSize: { xs: "16px", md: "20px" },
          }}
        >
          Valider les informations
        </MainButton>

        <Button
          variant="text"
          onClick={() => {
            updateDeliveryStatusBySMS(DeliveryStatus.CANCELLED_BY_CUSTOMER);
          }}
          sx={{
            textDecoration: "underline",
            fontSize: "1rem",
            fontWeight: 500,
            color: "text.primary",
            "&:hover": {
              textDecoration: "underline",
              color: "error.main",
            },
          }}
        >
          Signaler une anomalie
        </Button>
      </Box>
    </>
  );
}

export default Buttons;
